export default {
  PERSONAL: [
    "Personal Health Management Solutions",
    "HMO PRODUCTS",
    "Core products of MediLink-Global, providing healthcare management service integrating with the best ",
    "medical resource and cost control solution",
    "Xinyanbao 2022",
    "Exclusive Insurance Coverage for Newborns",
    "No Waiting Period for Outpatient Visits",
    "Medical experts accredited by MediLink-Global",
    "24-hours health management service",
    "Cashless Direct Billing with Health Card",
    "Full coverage for outpatient, emergency and inpatient medical services",
    "from",
    "RMB3,999",
    "Learn more",
    "Insured’s age: ",
    "30 days - 17 years old",
    "Insurance period",
    "1 year",
    "Fuyanbao",
    "No claim bonus - extra benefit of physical examination pack,if no claims in policy year",
    "High limit up to 2 million for hospitalization, exclusive medical service at designated private hospitals ",
    "This Exclusive High-end Medical Program for the Elderly is only available here",
    "RMB5,470",
    "46-80 years old (inclusive)",
    "Xiaoyanbao",
    "Effective immediately! Upon the premium payment date",
    "Offering 3 emergency or outpatient visits with 100% reimbursement",
    "Covering major high-end private hospitals (as listed)",
    "Convenient cashless payment through direct-billing",
    "30 days - 17 years old",
    "RMB3,888",
    "STANDARD PRODUCTS",
    "Tailor-made medical plans for middle/high-end cutomer group. You may choose differnt plans to setup ",
    "a combined program so as to enjoy the exclusive high-end medical service with effective price at the same time",
    "Zhenrongyao 2022 – Personal Global Medical Insurance",
    "Cashless Direct Billing with Health Card",
    "Flexible choice between middle / high-end plans",
    "Extensive medical coverages to cover your health",
    "Flexible options for Parents-children combined program ",
    "RMB4,748",
    "15 days - 64 years old",
    "FULL-CYCLE HEALTH MANAGEMENT PRODUCTS",
    "To provide customers with one-stop high-quality attentive services.  To cover the whole life journey from birth to death.",
    "To escort your health and to enjoy a wonderful life.",
    "Coming Soon",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  HOME: [
    "298+",
    "Core cities",
    "226+",
    "Countries and regions",
    "1.4million+",
    "Customers",
    "40+",
    "Insurance companies",
    "MediLink Products Hotline",
    "MediLink Partner Hotline",
    "Product Family", //11
    "Xinyanbao 2022",
    "Exclusive insurance coverage for newborns (30 days +)",
    "No waiting period for outpatient visits",
    "Xinyanbao Certified Doctors",
    "24-hour health management service",
    "Cashless direct billing with card",
    "Full coverage for outpatient, emergency and inpatient medical services",
    "Zhenrongyao 2022 – Personal Global Medical Insurance",
    "Cashless direct billing with card",
    "Diverse mid- and high-end plans",
    "Comprehensive medical coverage",
    "Flexible parent-child options",
    "MORE",
    "MediLink-Global",
    "Whole Life Cycle Health Management Service Platform",
    "Cooperative Hospitals Worldwide",
    "993,941 cooperative hospitals",
    "8,229 cooperative hospitals",
    "12,592 cooperative hospitals",
    "8,482 cooperative hospitals",
    "6,364 cooperative hospitals",
    "Europe",
    "North America",
    "Africa",
    "Middle East",
    "Asia",
    "Cover 226 countries and regions",
    "Hospitals Offering Direct Billing Service",
    "Over 1,800 cooperative hospitals in 286 provinces and cities",
    "Join Our Networ", // index=40
    "Products and Service",
    "Offer comprehensive third-party management services regarding high-end medical insurance",
    "Partners ",
    "Serve dozens of insurance customers of prestigious insurance companies at home and abroad and of wholly foreign-owned insurance companies",
    "",
  ],
  about: [
    "About MediLink-Global",
    "Profile",
    "Development History",
    "Business Model",
    "Partners", // 5
    "MediLink-Global - Whole Life Cycle Health Management Service Platform",
    "About MediLink-Global",
    `Founded in 2005, MediLink-Global is a whole-life-cycle health management service platform with an impressing size of business and significant influence in China. The company has its business covering 1.4 million medical service networks as well as more than 40 insurance companies in and outside China, and has served over 150,000 members worldwide with high-quality, professional and convenient whole-life-cycle health management and claims services.\n 
    Core advantages of MediLink-Global:\n 1. Scale of business: An extensive global medical network and abundant medical expert resources\n
    2. Whole-life-cycle services: Provide high-net-worth customers of all ages with health management services covering their entire life\n
    3. Exclusive services: Offer mid-to-high-end medical insurance products and exclusive top health management services\n
    4. Medical cost control: Offer efficient and reasonable resource allocation while ensuring the same medical results
    `,
    "Mission",
    "Be your whole-life-cycle health management expert!", // 10
    "Vision",
    "Be a model of the whole-life-cycle health management industry",
    "Values",
    `About business: Be honest and stay true
    About stakeholders: Keep promises and seek win-win cooperation
    About customers: Quality first, and service foremost
    About employees: Fairness, mutual understanding, and optimism
    `,
    "About us",
    "News center",
    "Videos",
    `Founded in 2005, MediLink-Global (hereinafter referred to as “MediLink") is a third-party service company specialized in health insurance management. `,
    `MediLink, which went public in the UK and possesses ECCS core management system, has become a whole-life-cycle health management service platform with an impressing size of operation and significant influence after 16 years of development. By October 2021, Shanghai-based MediLink-Global had established cooperation with nearly 3,000 international departments, special departments and VIP departments of prestigious Grade-III and Level-A hospitals and high-end Chinese-invested and foreign-invested private hospitals in 298 key cities in China, had its business covering 1.4 million medical and health service networks in 226 countries and regions as well as more than 40 well-known insurance companies in and outside China, and had served over 150,000 members worldwide with high-quality, professional and convenient whole-life-cycle health management and claims services.`,
    `In November 2019, MediLink joined and became an integral part for strategic upgrading of Nanyan Group, and embarked on accelerated development. Relying upon strong technical support from Nanyan Group, continuous efforts made in quality improvement, and extensive healthcare service network, a powerful team of excellent doctors and experts, and a professional service team made up of top health managers, MediLink has managed to provide high-net-worth customers with one-stop personalized and tailor-made whole-life-cycle health management services covering their entire life, and aims to continue to offer valuable whole-life-cycle health management services to its customers throughout the world based on the health concept of “prevention before disease attack” and by virtue of more cost-effective insurance products and healthcare services.`,
    `In September 2021, MediLink introduced “MediLink • Yi Xing”, a high-end medical institution providing high-net-worth customers with family and multidisciplinary clinical diagnosis and treatment services, which reflected the shift of MediLink from a single international medical insurance service platform into a “data-empowered, scenario-first and service-oriented” whole-life-cycle health management service platform. Aiming to “be a whole-life-cycle health management expert”, MediLink-Global has been cemented its ties with customers, medical institutions/medical groups and insurance companies to make its due contributions to the enhanced people’s livelihood and well-being and a “Healthy China”.`,
    "Core advantages of MediLink-Global",
    "Scale of operation:",
    "An extensive global medical network and abundant medical expert resources",
    "Whole-life-cycle services:",
    "Provide high-net-worth customers of all ages with health management services covering their entire life",
    "Exclusive services:",
    "Offer mid-to-high-end medical insurance products and exclusive top health management services",
    "Medical cost control:",
    "Offer efficient and reasonable resource allocation while ensuring the same medical results",
    "About business: Be honest and stay true",
    "About stakeholders: Keep promises and seek win-win cooperation",
    "About customers: Quality first, and service foremost",
    "About employees: Fairness, mutual understanding, and optimism",
    " ", //index===34
    "Established Beijing Head Office and Shanghai Branch; and engaged in third-party health insurance management and striving to be the leader and benchmark of the industry",
    "Developed the most advanced claim system enpowering the high-end medical industry to provide cashless direct billing service; by then MediLink was the sole pioneer service provider . ",
    "Awarded with “ISO9001:2008 Accreditation Certificate” and “ISO/IEC27001 Accreditation Certificate” for Information Security Management System",
    "Focused on high-end medical insurance service over 15years and joined Nanyan Group in November",
    "Working with major insurance companies in China in the field of medical insurance, and reach the service scale over  150,000 enrolled members and 3200 well known enterprises",
    "Awarded the title of “Specialized, Excellent, Featured and Innovative” Enterprise in Shanghai in February",
    "In February, the Nanyan Wechat-link Platform Software Service was selected as one of the winners in “12th Batch of High-tech Transformation Achievement in Shanghai of 2020",
    "",
    "In October, acquired another high-end medical network provider, WholeHealth, which focuses on workplace healthcare solutions with integrated healthcare solution platform. ",
    "Development History",
  ],
  about1: [
    "Ensure the security and professionalism of data processing; bring greater value to partners; provide high-quality services for members",
    "Development History",
    "MediLink(Beijing)TPA Services co., Ltd was founded in Beijing, China.",
    "Established the direct-billing service and keeps the only provider in the market of real-time claim solution until now. ",
    /*5*/ "Golden sponsor of the Kuala Lumpur conference of Asian Insurance Medicine Seminar.",
    'Gained the "ISO9001:2008 system certification certificate" and "ISO / IEC27001 information security management system certification certificate".',
    "Golden sponsor of the Hong Kong conference of Asia Insurance Medicine Seminar.",
    "Joined Nanyan and became one of its subsidiaries in November 2019.",
    "Works with more than 40 insurance companies, providing professional health insurance services to more than 150,000 members and 3,200 large enterprises.",
    "Business model:", // 10
    "Insurant",
    "Enjoy the cash-less services of medical institutions and feel the convenience of receiving medical treatment",
    "Eliminate troublesome claims procedures;",
    "Avoid the embarrassment of cash insufficient .",
    "Medical", // 15
    "Improve patients’ experience of receiving medical treatment and their satisfaction with the  institutions;",
    "Bring stable business volume",
    "Cooperative relationship between international-standard medical institutions and insurance companies.",
    "Insurance companies",
    "Enhance the attractiveness of insurance products to policy holders;", // 20
    "Reduce administrative expenses in claims management;",
    "Achieve safe and convenient claims and settlement, reduce the risk of medical expenditure.",
    "Partners",
  ],
  videoCenter: ["Video Center", "Company activities"],
  PAS: [
    "Products and Services",
    "Third-Party Administration (TPA) services",
    "Membership Services",
    "Health Services",
    "Search Medical Networks", // 5
    "Third-Party Administration (TPA) services",
    "professional Third-Party Administration (TPA) services",
    "Service overview",
    "Medilink is principally involved in providing Third Party Claims Administration (TPA) services by operating a state-of-the-art electronic network infrastructure to facilitate healthcare claims processing.Medilink is presently the only Third Party Administrator with regional presence operating in China, having deployed China first secured and trusted electronic network and provides third-party health insurance management services for Chinese and foreign insurance companies and self-insurance companies in China, Greater China, Asia and even the world .",
    /*10*/ `The Medilinkl System facilitates online real-time eligibility verification and confirmation of benefits as well as automated adjudication of out-patient healthcare claims. Each member carries an electronic card which is presented to the registration desk in the Physicians Office when seeking treatment. The card shall be swiped at the EDC sends electronic signals to Medilink's back-end shall return an impulse back to the EDC Terminal within seconds.`,
    "Service introduction:",
    `On-line Pre-consultation eligibility verification On-line Post-consultation claims data capture and validation`,
    `Claim payment processing including direct payment service`,
    `Administrative arrangements for financial guarantees`,
    /*15*/ `Post-admission follow-up Pre-discharge - adjudication of hospital bills`,
    `Communication of disapproval or non-admissibility of medical diagnosis Post-discharge claims documentation`,
    `Benefits for members:`,
    /*18*/ `Online real-time identity verification`,
  ],
  PAS1: [
    `Proven technology in terms of security, reliability, availability & confidentiality`,
    `Timely and Effective online real-time Reporting`,
    `Hassle free Registration and Paperless Administration`,
    `State of-the-art secured and trusted electronic healthcard network`,
    /*5*/ `Wide selection of network healthcare providers`,
    `Know-how and cross Regional Expertise to constantly conduct professional utilization review for better cost containment`,
    `Special service:`,
    `Introduction of the electronic claims management system`,
    `The MediLink system provides management services of medical claims and medical data for insurance companies, enterprises and third-party management institutions by supporting the electronic medical card network.`,
    /*10*/ `Safe and reliable techniques:`,
    `Each EDC terminal deployed in the medical institutions is installed with proprietary software of MediLink to verify the medical cards distributed by MediLink. Just like a credit card verification program, when the cardholder goes for medical advice, the front desk staff of the medical institution can use the MediLink’s medical card on the designated ECD terminal to confirm the cardholder’s identity.`,
    `The Medilink-Global’s Claims Management System (E.C.C.S.), which runs on the Oracle Database platform, is a complete suite of highly customized system designed for healthcare claims processing and healthcare data management. The software manages various databases pertaining to the Healthcare Payer and its members, their Health Plans, Benefits, Coverage, Exclusions, Specified Conditions and Conditions.`,
    `Benefits for users:`,
    `Electronic real-time identity confirmation and benefits confirmation`,
    /*15*/ `Flexible, universe and highly customizable`,
    `Provide highest-standard services through latest and best applications and techniques`,
    `Safe and reliable electronic medical network`,
    `How the system works:`,
    `The MediLink system consists of the front-end electronic data collection terminal (EDCT) network and the back data center supported by our customized electronic claims processing system.`,
    /*20*/ `Dental clinics`,
    `Medical management organizations (HMO)`,
    `Membership Services`,
    `Telephone consultation service`,
    "pharmacies",
    /*25*/ "examination rooms",
    "clinics",
    "hospitals",
    "insurance companies",
    "appraisal companies",
    /*30*/ "enterprise groups",
    "third-party management agencies (TPA)",
  ],
  PAS2: [
    `Professional trained gservice team`,
    `Member insurance benefits inquiry`,
    `Networked medical institution recommendation`,
    `Networked medical institution appointment and arrangement`,
    /*5*/ `Member-related questions and answers`,
    `Networked hospital information inquiry`,
    `Telephone Consultation Service`,
    `Telephone answer within 15 seconds`,
    `Failure rate `,
    /*10*/ `Single call processing rate`,
    `Hospital on-site service`,
    `List of resident hospitals`,
    `Official Accounts service`,
    `Scan the QR Code below，or search for【MedilinkOnline】on Wechat Service Platform. Click 【Follow】to enjoy online services.benefits enquiries、Hospital enquiries、Claims processing 、Pre-authorization `,
    /*15*/ `Corporate Health Services`,
    "(call back within two hours)",
    "on-site service in main networked hospitals",
    "member welfare inquiry",
    "identity confirmation",
    /*20*/ "medical guidance and language assistance",
    "self-paid amount collection",
    "deduction of insured amount",
    "Peking Union Medical College Hospital",
    "Shanghai east Hospita tongji  University",
    /*25*/ "Shanghai Landseed Hospital",
    "The first affiliated hospital soochou university",
    "China-Japan Friendship Hospital",
    "Ruijin Hospital",
    "Shanghai Jiaotong University School of Medicine",
    /*30*/ "Huashan Hospital Affiliated to Fudan University",
    "Children’s Hospital of Shanghai",
    "Beijing Anzhen Hospital",
    "Shanghai huadong Hospital",
    "Renji Hospital Affiliated to Shanghai Jiaotong University School of Medicine",
    /*35*/ "Suzhou Kowloon Hospital",
    "Shanghai Longhua Hospital",
    "benefits enquiries",
    "Claims processing",
    "Hospital search",
    "Hospital navigation",
    "FAQ",
  ],
  PAS3: [
    `Service overview`,
    `Maintaining health and treating diseases have always been the two main focus of MediLink-Global. While providing third-party management services for health insurance products, MediLink-Global focuses on tapping medical resources from its direct payment network and strives to provide insurance companies, corporate groups and individuals with value-added health-promoting and convenient medical services. By cooperating with medical institutions and partners, MediLink-Global summarizes and organizes online medical resources to form a variety of health and medical services to help customers get a healthy and convenient medical consultation.`,
    `Cross-border Medical Services`,
    `Among today's health conscious society, seeking healthcare treatment in a foreign country should be made as easy as seeking treatment in own country.`,
    /*5*/ `Medilink thus offers cross border healthcare solutions to all eligible members via its strategic tie-ups with leading healthcare providers in South East Asia, China and from as far as in the USA`,
    `The logistics and complexity involved in traveling from one country to another in seeking medical treatment is easy`,
    `How we work`,
    `Medilink-Global has special arrangements with selected healthcare providers not only in providing advice and also in facilitating and arranging for specialized medical treatment (secondary or tertiary care) at reputable medical institutions.In short, Medilink-Global will act as a one stop co-ordinator and facilitator for the Member in seeking advice on a particular specialized medical treatment.The actual expenses incurred when seeking medical services at these selected medical shall be the sole responsibility of the member.`,
    `Our services`,
    /*10*/ "identify renowned medical institution",
    "arrange medical appointment",
    "arrange specialized treatment",
    `Benefits for members`,
    `convenient access to MEDILINK's pre-established medical network specializing in secondary and tertiary care medical treatment. `,
    /*15*/ `Convenient access to the cross-border medical information.`,
    `On-stop arrangement for cross-border treatments. `,
    `Telephone consultation`,
    `membership confirmation`,
    `initiation of the service network`,
    /*20*/ `detailed service arrangement`,
    `diagnosis and treatment`,
  ],
  TCMN: [
    "Traditional Chinese Medicine Network",
    "Service overview",
    `TCM, namely Traditional Chinese medicine, originating in China. Today, the number of people seeking TCM treatment is increasing rapidly. The theory of TCM originated thousands of years ago, which was formed through continuous exploration of nature, the universe and the human body. TCM treatment includes Chinese herbal medicine, acupuncture, diet therapy, finger-pressing massage, etc. Qigong and Taijiquan are also closely related to TCM. Though widely accepted in South Asia, TCM is only regarded as an alternative therapy in the medical system in many Western countries. After developing its business in China, MediLink-Global now can provide members with TCM medical institutions that can provide TCM treatments for various diseases.`,
    `How to realize?`,
    `MediLink-Global can arrange a selected TCM medical institution to provide medical advices as well as arrange treatments for various diseases.`,
    `MediLink-Global will collect your needed information and feedback to the doctor to recommend you to a corresponding and appropriate TCM medical institution based on your situation.`,
    `MediLink-Global will further help members seek treatments.`,
    `All the expenses incurred in the actual TCM treatments should be afforded by the member.`,
  ],
  BFM: [
    "Benefits for Members",
    "Provide convenience for members to visit selected TCM medical institutions",
    "Traveling to China for medical cares will be easy with the assistance of MediLink-Global.",
    "Members can plan their treatments in advance and enjoy a relaxing trip.",
    "Access of TCM information will be easy via MediLink-Global.",
    "Second Medical Opinion",
    "Service overview",
    "The Second Medical Opinion service allows you obtain advices on your disease from the best experts of the world’s top medical institutions without leaving your home.",
    "How to get a second medical opinion?",
    "As a valid member of the Second Medical Opinion service, if you are diagnosed (or suspected) to have a serious disease, you can apply for a second medical opinion.",
    "Your disease must be a type included in the disease list we have provided. Once the requirements are met, MediLink-Global will collect all relevant medical records with your assistance and send them to the selected medical institution for a second medical opinion, based on your authorization.",
    "Generally speaking, the second medical opinion will be completed within ten working days after the selected medical institution has received the materials.",
    "",
  ],
  SOS: [
    "Scope of Services",
    "Provide reliable medical information for you, your family and your doctor.",
    "The related staff of the Second Medical Opinion service will complete the application for a second medical opinion for you, to save you from the trouble of long-distance travel for medical care.",
    "Usually the second medical opinion will be completed within ten working days after the selected medical institution received the materials.",
    "After the member received the second medical opinion, MediLink-Global will continue to provide hospitalization arrangements and other services within our capability.",
    "",
  ],
  BFM1: [
    "Benefits for Members",
    "Save the travel expenses and accommodation expenses for members seeking a second medical opinion.",
    "Relieve the psychological pressure of members and let members better understand the second medical opinion.",
    "Pre-existing disease or not, a second medical opinion can be applied for any disease as long as it’s included in the disease list of the Second Medical Opinion service.",
    "",
  ],
  EMA: [
    "Emergency medical assistance",
    "Service content introduction",
    "Emergency medical assistance (MEA) service is to provide assistance services to people who encounter sudden illness, accidental injury or have medical needs during travel, including transferring patients to medical institutions for treatment or transporting them back to their place of residence. The aim of the MEA service is to provide timely and appropriate solutions for people in urgent need of medical assistance or arrange them in time to transfer them to more suitable locations for treatment.",
    "Our services",
    /*5*/ "telephone doctor consultation service",
    "medical recommendation and appointment arrangement",
    "arrangement of doctor visits",
    "arrangement of admission guarantee",
    "arrangement of emergency medical evacuation",
    /*10*/ "medical condition tracking and conveying information to family members",
    "transporting remains abroad back to the country",
    "How we work?",
    "Emergency Medical Assistance",
    "The Emergency Medical Assistance of MediLink-Global covers the world. When an emergency medical need occurs, the assistance service can be quickly activated and the corresponding service can be arranged based on the detailed situation of the vehicle asking for help.",
    /*15*/ "24-Hour Multi-lingual Service",
    "MediLink-Global provides 24-hour multi-lingual assistance service. MediLink-Global can promptly provide online or on-site emergency medical assistance services or arrangements for members traveling abroad.",
    "Benefits for Members",
    "Overseas travel at ease and with peace of mind.",
    "Conveniently enjoy the XXX of MediLink-Global all over Southeast Asia, China and other countries",
    "",
  ],
  IC: [
    "Information center",
    "Recent news",
    "Media reports",
    "FAQs",
    "File download", // 4
    "September 2020 ",
    "August 2020 ",
    "July 2020 ",
    "June 2020 ",
    " | MediLink-Global New Direct Billing Hospital", //9
    "May 2021",
    "April 2021",
    "March 2021",
    "February 2021",
    "For more information", // 14
    "(a)",
    "(b)",
    "October 2020 ",
    "November 2020 ", //18
    "December 2020",
    "New Year's Day Holiday | Holiday Arrangements For Some Direct Billing Hospital In The MediLink-Global",
    "January 2021", //21
    "June 2021",
    "July 2021",
    "August 2021",
    "September 2021",
    "October 2021",
    "November 2021",
    "December 2021",
  ],
  FAQ: [
    "FAQs",
    "What is TPA?",
    "Third Party Administrators",
    `Third Party Administrators, TPA for short. It is widely adopted in European and American countries as a successful operating model of the financial service industry. It can make up for the gap between the insurance industry and medical institutions, bring benefits to both insurers and the insured. The insured  will get better medical and insurance services, while the management cost of the insurers will be reduced and the medical institutions will have a stable patient source (customer source) and income. Since the goal of multi-win can be easily achieved just with the help of TPA, it has been widely recognized by insurance companies, enterprises and individuals and medical institutions although it’s only a new thing in our country.`,
    `The origin of TPA?`, // 5
    `Because it is very difficult to control the risk from group health insurance, 
        insurance companies usually only provide very limited products with high prices, 
        therefore some large corporate groups have to set up their own health coverage 
        with company’s resources. Although this method is able to avoid complicated 
        insurance claim procedures and it is good to control the cash flow in the company, 
        but this system cannot handle some special risks, and sometimes due to the problems 
        during the internal claim procedure, the cost is also hard to be controlled... 
        Moreover, it is also hard to efficiently control medical expense risks since 
        insurance companies have not formed a community of shared interests with medical 
        service providers. More importantly, due to the fact that currently insurance 
        companies lack data accumulation related to diseases and medical expenses, 
        the actuarial foundation is not solid and because of their insufficient talent 
        accumulation and low degree of specialization, these companies are gradually 
        paying more attention to how to meet the needs of more and more customers 
        for better health care and are looking for guidance to better find the way of 
        health care. The emergence of TPA can alleviate this unbalance between supply 
        and demand to a certain extent. Because TPA is only responsible for management 
        and because insurance companies can accumulate valuable data through TPA, laying 
        a solid foundation for future development of health insurance products and setting 
        reasonable prices becomes very important. Clients trust their own health insurance 
        plans with a third-party management company that is experienced in this industry to 
        manage and let the latter choose a highly professional insurance company to be 
        responsible for underwriting and assuming the risks of payment. TPAs obtain 
        corresponding management expenses from insurance companies by providing professional 
        management services.`,
    `Who are benefited from third-party management?`,
    `Policyholders will benefit from the easier access to care and settlement of hospital bills. At network hospitals, policyholders will enjoy cashless settlement at discharge. Furthermore, the cost of medical insurance cover will be more affordable due to more efficient use of medical care.
        Insurers will be able to increase the service standards provided to their policyholders, thereby differentiating themselves from other insurers. Additionally, they will have more confidence in calculating the cost of providing medical insurance cover. This means insurers will be able to offer more affordable medical insurance cover to their customers.`,
    `What does direct-billing hospital mean?`,
    /*10*/ `direct-billing means that as long as you show your insurance card when seeking medical care in our networked hospitals, you can enjoy cash-free treatment and the hospital will bill us directly. You only need to pay the self-afforded part of the medicine expense and the expense not covered by the insurance.`,
    `File download`,
    "Medilink pre-authorization form ",
    "MGU pre-authorization form",
    "Medilink member reimbursement claim form",
    "MGU member reimbursement claim form",
  ],
  LOGIN: [
    "Login",
    "Member Login",
    "Institution Login",
    "Partner Login",
    /*5*/ "Head office address: 10F, Jingtai Building, No. C24, Jianguomenwai Avenue, Chaoyang District, Beijing",
    "Contact: ",
    "Mail editor: ",
    "Fax: ",
    "Website: ",
    "Member/Institution/Partner Login",
  ],
  AMG: [
    "About MediLink-Global",
    "Product Family",
    "Third-party Management Services",
    "Medical Services",
    "Company profile",
    "Development History", // 5
    "Core advantages",
    "Corporate Health Management Solutions",
    "Personal Health Management Solutions",
    "Xinyanbao",
    "Xiyanbao", // 10
    "Fuyanbao",
    "Xiaoyanbao",
    "Zhenrongyao",
    "Third-party Management Services",
    "Membership Services", // 15
    "Special Services",
    "",
    "Corporate Health Service",
    "Copyright©2008-2020 MediLink-Global. ALL RIGHTS RESERVED. J. ICP B. No. ",
    "No. 11010502030494", // 20
    "MediLink-Global Online",
    "24-hour MediLink-Global",
    "MediLink-Global",
    "08007346-1",
    "J. G. W. A. B.", // 25
    "Zhengaoduan",
    "Zhenheyi",
    "Xinyanbao(Global)",
    "MediLink-Global Assist"
  ],
  ML: [
    "Direct-Billing Hospital network--Mainland area",
    "Join our network",
    "Mainland representative network hospital",
    "Please select province",
    "Please select city", // 5
    "Anhui",
    "Beijing",
    "Fujian",
    "Gansu",
    "Guangdong", // 10
    "Guangxi",
    "Guizhou",
    "Hainan",
    "Hebei",
    "Henan", // 15
    "Heilongjiang",
    "Hubei",
    "Hunan",
    "Jilin",
    "Jiangsu", // 20
    "Jiangxi",
    "Liaoning",
    "Inner Mongoria IM",
    "Ningxia",
    "Qinghai", // 25
    "Shandong",
    "Shanxi",
    "Shanxi",
    "Shanghai",
    "Sichuan", // 30
    "Tianjing",
    "Xinjiang",
    "Yunnan",
    "Zhejiang",
    "Chongqing", // 35
    "AoMen",
    "Hong Kong",
    "Taiwan",
    "Tibet",
    "Direct-Billing Hospital network--Overseas", // 40
  ],
  ML1: [
    "Select nature",
    "all",
    "private",
    "public",
    "foreign", // 5
    "Select level",
    "3A",
    "3B",
    "3C",
    "2A", // 10
    "2B",
    "2C",
    "1A",
    "1B",
    "1C", // 15
    "NO",
    "Select category",
    "General Hospital",
    "Dental hospital",
    "Dental clinic", // 20
    "Specialized Hospital",
    "General Clinic",
    "specialist clinics",
    "Physical Examination Center",
    "PHARMACY", // 25
    "laboratory",
    "Maternity Hospital",
    "pediatric Hospital",
    "pediatric Clinic",
    "Women's and Children's Hospital", // 30
    "Orthopaedic Hospital",
    "rehabilitation Clinic",
    "eye hospital",
    "eye clinic",
    "TCM Clinic", // 35
    "Cancer Clinic",
    "TCM Hospital",
    "For more information",
    "Please enter the name of the hospital",
    "Please enter your departure", // 40
    "Select country", // 请选择国家
    "Select State", // 请选择州/省
    "Select city", // 请选择市
    "Please Select country or State",
  ],
  JOIN: [
    "How to join our network?",
    "Online Application Form",
    "MediLink Network department will contact you",
    "After the assessment, by the head of the network final review",
    "Collaboration feedback via email", // 5
    `If the intention of cooperation is reached, the contract will be signed offline
            Start filling out the application form`,
    "Apply now",
    "providerType",
    "providerCatg",
    "First page",
    "Prev", // 10
    "Next",
    "Total {pages} pages",
    "BEIJING"
  ],
  OVERSEAS: [
    "Direct-Billing Hospital network--Overseas",
    "Representative Providers",
  ],
  distanceList: [
    "Within 5km",
    "Within 10km",
    "Within 15km",
    "Within 20km",
    "Within 30km",
    "The above of30km",
  ],
  vipServiceLogin: [
    "Sign in with user ID and password",
    "Please enter your insurance card number starting with 800",
    "Please enter your password (the last six digits of your ID card number by default)",
    "Please enter your verification code",
    "Remember me",
    "Forget password?",
    "Sign In",
  ],
  vipServiceContent: [
    "Membership Services",
    "With the increasingly strong health awareness, seeking medical services abroad will become as easy as that at home.In view of this need, MediLink-Global provides its members with cross-border medical services through the medical institutions in Southeast Asia, China and the United States that are in close cooperation with it.This arrangement significantly simplifies the process of traveling from one country to another country to seek medical services.",
    "Telephone Enquiry Service",
    "Well-trained professional service team",
    "Well-trained professional service team",
    "Membership insurance benefits inquiry",
    /*5 */
    "Appointment arrangement with online medical institutions",
    "Q&As for members",
    "Information inquiry about online hospitals",
    "7*24*365 telephone enquiry service",
    "Phone answer within 15 seconds > 98%",
    /**10 */
    "Call loss rate < 5% (call back within two hours)",
    "Single call processing rate > 90%",
    "On-site Services at Hospitals",
    "Well-trained professional service team",
    "Member insurance benefit query", //15
    "Membership insurance benefits inquiry",
    "Appointment arrangement with online medical institutions",
    "Q&As for members",
    "Information inquiry about online hospitals",
    "", //20
    "On-site Services at Hospitals-ShangHai",
    "On-site Services at Hospitals-BeiJing",
    "On-site Services at Hospitals-SuZhou",
    "On-site Services at Hospitals-ZheJiang",
    "On-site Services at Hospitals-SiChuan",
  ],
  hospitals: [
    "Telephone Enquiry Service",
    "Peking Union Medical College Hospital",
    "Shanghai East Hospital",
    "Shanghai Landseed International Hospital",
    "The First Affiliated Hospital of Soochow University",
    "China-Japan Friendship Hospital",
    "Shanghai Ruijin Hospital",
    "Huashan Hospital Affiliated to Fudan University",
    "Shanghai East Hospital",
    "Shanghai Children’s Medical Center",
    "Beijing Anzhen Hospital",
    "Shanghai Huadong Hospital",
    "Shanghai Renji Hospital",
    "Suzhou Kowloon Hospital",
    "Shanghai Longhua Hospital",
  ],
  thirdPartService: [
    "Professional Third-party Management Services",
    "Service Overview",
    "With an advanced electronic healthcard network that processes claims for medical expenses, MediLink-Global provides third-party reimbursement service. MediLink-Global provides third-party management services for insurers and captive insurance companies at home and abroad in respect of health insurances covering China, Grater China region, Asia and the globe, through its safe and reliable direct billing network.",
    "MediLink-Global system allows members to check their insurance benefit at any time and any place and settles in real time the reimbursement for outpatient service. An electronic healthcard will be issued to each member, and should be presented to the healthcare provider. Staff at the healthcare provider will help members use this card with the MediLink-Global EDC machine that can transmit the data from the healthcare provider to our internal system within a few seconds.",
    "Service Introduction",
    "Verification of identity before online visit; capture and validation of claim data after online visit",
    "Reimbursement process includes direct billing service",
    "Administrative process of payment secured by medical",
    "Admission tracking and reviewing medical expenses before discharge",
    "Communication for confirmation of diagnosis not reviewed; collect application documents for claims",
    "Membership Benefits",
    "Online identity verification in real time",
    "Safe, reliable, confidential and widely accepted technology.",
    "Time-saving and efficient spreadsheet system",
    "Simple registration procedure and paperless management",
    "Cutting-edge, safe and credible electronic healthcard network",
    "A network covering a wide range of healthcare providers",
    "Experienced processing of cross-regional claims, and professional risk control.",
    "Signature Services",
    "About Electronic Claim System",
    "MedeLink-Global provides insurers, corporations and third party administrators with medical expenses reimbursement service and medical data management service by developing an electronic healthcard network.",
    "Safe and Credible Technology",
    "At each medical partner installs a EDC machine embedding MediLink-Global's proprietary software that is used to verify the healthcard issued by MediLink-Global. Like verification of a credit card, the receptionist of a healthcare provider will use the MediLink-Global healthcard with EDC machine to confirm that the person receiving services is the holder of the healthcard.",
    "MediLink-Global ECCS is a customized system for reimbursement for medical expenses and management of medical data. It is designed with a view to effectively managing various databases, including healthcare payor, MediLink-Global members, their health plans, benefits, liabilities, exclusions and diseases not covered.",
    "Benefits to Members",
    "Identity verification and benefit check in an electronic way and in real time",
    "Flexible, general and customized system",
    "State-of-the-art applications and technologies help provide the best services",
    "Safe and credible electronic healthcare network",
    "How the System Works",
    "MediLink-Global system is composed by an electronic data capture terminal (EDCT) and a data center supported by a customized electronic reimbursement processing system.",
    "Dental Clinics",
    "Pharmacies",
    "Examination Rooms",
    "Clinics",
    "Hospitals",
    "Hospital Management Organizations",
    "Insurance companies",
    "Insurance Assessment Companies",
    "Corporate Bodies",
    "Third Party Administrators",
    "Partners Network",
  ],
  specialServiceTab: [
    "Second-time diagnosis and treatment services",
    "Cross-border medical services",
    "Emergency rescue services",
  ],
  specialServiceContent: [
    "Second Opinion",
    "Service Overview",
    "The second opinion service allows you to get diagnosis opinion on your disease at home from the best experts from top medical institutions worldwide.",
    "How to get second opinion?",
    "If you are a registered member of the second opinion service and you are diagnosed with (or are suspected of suffering from) any severe disease, you can apply for second opinion.",
    "However, the disease you are suffering from must be on the list of diseases covered in the benefit plan of the policy. Once all the requirements are met, MediLink-Global will, with your authorization and assistance, collect all the medical records required and send them to the selected medical institution for second opinion.",
    /*5*/
    "Generally, second opinion will be given to you within ten (10) working days after the medical records are received by the selected medical institution.",
    "Service Description",
    "The second opinion service will provide you and your family and doctor with reliable medical information.",
    "The second opinion service staffs will transact the application for second opinion on your behalf to save you from long trips.",
    "Generally, second opinion will be given to you within ten (10) working days after all the medical records required are received by the selected medical institution.",
    /*10*/
    "MediLink-Global will continue to provide you with hospitalization arrangements and other services as far as possible after you get second opinion.",
    "Membership Benefits",
    "Save travel and hotel expenses for members seeking second opinion",
    "Relieve mental stress of members and help members to better understand second opinion",
    "Any member who suffers from the disease on the list of diseases for second opinion can apply for second opinion, regardless of pre-existing diseases",
    /*15-跨境就医服务*/
    "Cross-border Medical Services",
    "With the increasingly strong health awareness, seeking medical services abroad will become as easy as that at home.",
    "In view of this need, MediLink-Global provides its members with cross-border medical services through the medical institutions in Southeast Asia, China and the United States that are in close cooperation with it.",
    "This arrangement significantly simplifies the process of traveling from one country to another country to seek medical services.",
    "How We Work",
    /**20 */
    "Working with preferred medical institutions in our network, MediLink-Global not only provides members with medical consultation and information, but also offers members the opportunity to receive specialist treatment at well-known medical institutions. To make it easy, MediLink-Global will act as a one-stop coordinator and liaison to help members seek advice on special specialist treatment. However, all medical expenses incurred for treatment and other related services at selected medical institutions will be solely borne by members.",
    "Our Services",
    "Select well-known medical institutions",
    "Schedule medical appointments",
    "Schedule specialist treatment",
    /* 25*/
    "Collect and summarize medical information",
    // 会员将享受到的福利
    "Membership Benefits",
    "Convenient access to MediLink-Global’s existing online medical institutions with grade-II and grade-III medical qualifications.",
    "Convenient access to cross-border medical information.",
    "One-stop cross-border medical arrangements",
    /*30*/
    "Telephone consultation",
    "Membership confirmation",
    "Service network activation",
    "Service arrangement",
    "Diagnosis and treatment",
    "Second-time diagnosis and treatment services", //35
    "Cross-border medical services",
    "Emergency rescue services",
    "Signature Services",
    "",
    "", //40
  ],
  // 紧急救援
  emergencyContent: [
    "Emergency rescue services",
    "Service Description",
    "Medical Emergency Assistance (MEA) is an assistance service provided to those who encounter sudden illnesses or accidental injuries or have emergency medical needs during travel, including transferring patients to medical institutions for treatment or to their domiciled place.The purpose of MEA is to provide those having emergency medical needs with timely and appropriate solutions, or make timely arrangements to transfer them to other appropriate places for treatment.",
    //我们的服务
    "Our Services",
    "Telephone medical consultation",
    /*5*/ "Medical recommendation and appointment scheduling",
    "Doctor’s visit scheduling Arrangement for guarantee for hospital admission",
    "Arrangement for emergency medical transfer",
    "Medical tracking and notice to family members",
    "Repatriation of remains from abroad",
    // 我们如何工作的
    /*10*/ "How We Work",
    "Medical Emergency Assistance",
    "MediLink-Global offers Medical Emergency Assistance throughout the world, and can quickly arrange the medical services as required according to the actual situation of the  patients when emergency medical needs occur.",
    "24-hour Bilingual Services (English & Chinese)",
    "MediLink-Global offers 24-hour bilingual assistance services, and can timely provide members traveling abroad with online or on-site Emergency Medical Services or arrangements.",
    // 会员福利
    "Membership Benefits",
    "Easiness and peace mind during your overseas travel.",
    "Entitlement to convenient network services covering Southeast Asia, China and other places.",
  ],
  // 医疗服务
  medicalservices: [
    "Medical Services",
    "Corporate Health Service",
    "MediLink-Global Corporate Health Service is intended to provide enterprises with comprehensive health solutions, and to provide employees with health care and health management services by relying on in-house medical center of enterprises.",
    "Units at Different Levels",
    "Doctor: 1; nurse: ≥1", //5
    ">100 square meters",
    "Qualified to offer medical services",
    "General consultation and treatment services, and drug dispensing",
    "Emergency Medical Services, and value-added healthcare services",
    "Health Center", //10 健康中心
    "Clinic", //医务室
    "Health Room", //健康小屋
    "Doctor: 1; nurse: optional",
    "Not qualified to offer medical services",
    "General diagnosis and treatment consulting services, and OTC drugs dispensing", //15
    "Emergency Medical Services, and value-added healthcare services",
    "Several doctors and nurses + management staff",
    "Emergency transfer vehicles",
    ">500 square meters",
    "Qualified to offer medical services", //20
    "General consultation and treatment services, and drug dispensing",
    "Construction of emergency system, and value-added healthcare services",
    "Optional Services",
    "Basic Services",
    "Project preparation/application for qualifications", //25
    "Routine diagnosis and treatment/Emergency Medical Services",
    "Intelligent Medical Services",
    "ERP system/HIS system",
    "Online consultation/intelligent supporting facilities",
    "Health Management", //30
    "Chronic disease management/occupational health",
    "Physiotherapy services/special services",
    "Medical Cooperation",
    "Consultation services offered by specialists/health lectures",
    "Health activities/green-channel services", //35
    "One-stop Health Management Service Plan",
    "Integrate medical and health product resources, effectively improve health management service capabilities, and meet diversified service needs of enterprises",
    "Emergency Medical Services",
    "Licensed first-aid trainings",
    "First aid facilities in place", //40
    "Emergency access",
    "Customized emergency plan",
    "Emergency drills",
    "On-site medical services",
    "Health Management", //45
    "Data Collection",
    "Physical examination reports",
    "Daily consultation records",
    "Personal health data",
    "High-risk Disease Screening", //50
    "High-risk factors analysis",
    "Health scale measurement",
    "Additional specialty examinations",
    "Precise targeting",
    "Health knowledge", //55
    "Health Management",
    "Health records making",
    "Professional medication advice",
    "Diet and exercise advice",
  ],
  // 企业健康管理方案
  healthPlan: [
    "Corporate Health Management Solutions", //企业健康管理方案
    "Overview of Corporate Customer Solutions",
    "MediLink-Global Corporate Customer Solutions are intended to solve various problems you may encounter in corporate health and medical services and to provide corporate customers with whole-life-cycle health management services by relying on cutting-edge technology, professional services, complete online process and professional medical experts!",
    "Competitive Advantages",
    "Tailor-made service plan", //5
    "To meet different budgets of customers",
    "One-stop solutions",
    "One-stop solution to meet cutomers’ medical needs",
    "Accredited doctor resources",
    "Provide comprehensive medical service", //10
    "Smart IT system & platform",
    "Provide convenient online service & support",
    "Case Study",
    "Enterprises under the “Belt and Road” Initiative: A large petroleum company",
    "The company became a high-end medical customer of MediLink-Global in October 2020l, and is the first customer with over 300 members since MediLink-Global started business operations. Considering that the customer needs to dispatch its employees to Iraq, Dubai and other places from time to time as needed for its projects, and that there are also the company’s employees and their family members in Canada, Morocco and other places, MediLink-Global rapidly ...", //15
    "Learn more",
    "Sino-foreign joint ventures: A large integrated circuit manufacturing company limited by shares",
    "The company became a high-end medical customer of MediLink-Global in July 2021, and has its medical plan covering outpatient, inpatient, childbirth, value-added and other services. MediLink-Global offers four service packages and various budget options for the company to meet its different needs. In order to meet the company’s need for medical visits based on the principle of proximity, MediLink-Global has ...",
    "A-share listed companies: A large pharmaceutical technology company",
    "The company became a high-end medical customer of MediLink-Global in March 2021. Considering that the company’s senior executives are dispatched to Hong Kong, Singapore and Australia from time to time, MediLink-Global provides the customer with a ...", //20
    "Large Internet companies: A large Internet company",
    "The company became a high-end medical insurance customer of MediLink-Global in June 2021. The company, as one of the leading tourism service companies in China, offers favorable benefits for its employees ...",
    "A-share listed companies: A multi international human resources company limited by shares",
    "Foreign-funded companies: A transnational foreign-funded company",
    "The company became a high-end medical insurance customer of MediLink-Global in November 2020. MediLink-Global offers health insurance services that cover inpatient, outpatient, dental and other high-end medical services for the company’s senior executives in Beijing, Shanghai, Suzhou and other places ...", //25
    "The company became a high-end medical insurance customer of MediLink-Global in November 2020. MediLink-Global provides the company with inpatient, outpatient, childbirth, physical examination, vision, dental, mental health, travel safety, and other ...",
    "Corporate Customer Health Management Solutions",
    "Corporate Customer Health Management Solutions:",
    `MediLink-Global as a health management expert commits to provide professional, tailor-made, comprenhensive health solutions to assure enterprise's employees in healthy conditions,  to improve working environment as healthy for the Company, and to assure your "Healthcare Strategy" in place. `,
    `The tailor-made program can be based on the company ownership type (private, , state, foreign), or based on the size and nature of the company (SME, nation-wide, world-wide).  And the program can be detailed and classified by number of staff, level of staff, occupancy nature,  the staff families etc. The successful records or solutions are listed as below for your reference. If you need more details, please feel free to dial our hotline for your own program.`, //30
    "Options",
    "Plan A",
    "Plan B",
    "Plan C",
    "Plan D", //35
    "Covered Territories",
    "Mainland China",
    "Mainland China, Hong Kong, Macau, and Taiwan",
    "Worldwide Excluded USA",
    "Worldwide", //40
    "Policy annual limit",
    "RMB3,000,000",
    "RMB6,000,000",
    "RMB8,000,000",
    "RMB10,000,000", //45
    "Hospitals Covered",
    "Public hospitals",
    "Public + private hospitals",
    "Public +Private+High cost Hospitals",
    "Public +Private+High cost Hospitals", //50
    "Outpatient treatment",
    "20,000",
    "50,000",
    "Included in the policy annul limit",
    "Included in the policy annul limit", //55
    "Other Benefits",
    "Inpatient Treatment",
    "Emergency Medical Services",
    "(Dental, physical examination, childbirth, and ophthalmology available)",
    "Optional", //60
    "In October 2020, the company joined MediLink-Global Health Program, more than 300 staff included in this membership project. As they need to travel to mid-east countries, such as Iraq, Dubai for their business or project, sometimes even dispacthed with their families. Also the business travel ocassionally cover Canada, Morocco and some other countries. Therefore, the Customer would need a service provider that can provide an integrated medical network quickly, especially in Iraq in one week. The program also needs to be able to process foreign currency payment, so as to assure our member can enjoy cashless direct billing service for medical payment.  For achieving this goal,",
    "Medilink-Global immediately set up a special service team quickly dealed the challenges and provide in-time solutions.  Furthermore, we also extended our services to more considerate fields such as pharmacy delivery, tracking service for critical illness, real-time online reimbursement and value-added services based on customer emerging needs.",
    `In July 2021, the company looked for an extensive medical plan covering outpatient, inpatient, maternity coverages together with value-added services.  MediLink-Global immediately worked with broker and company's HR to work out four high-end medical plans based on customer's budget and expectation. These plans also offer coverage adjustment options to meet customer's budget affordability. The most impressive things were the flexibilty of the plan, such as medical visits based on the principle of proximity. MediLink-Global made arrangement with reputable public hospital near the customer's workplace, and the hospital can provide high-quality medical services with pleasing environment exactly meet customer's expectaion. In order to assure the payment service, we also arranged direct-billing agreement with the hospital. This considerate action has been well received by the customer.`,
    'MediLink-Global has been in China market since 2005, and has been aimeing to expand its local network provider including VIP Departments, Special Departments or International Departments of the public hospitals and qualified private hospitals with comprehensive service capabilities.  By means of such extensive "direct billing medical network and billing services, the members of MediLink Global can easily enjoy medical treatment services without cash pay, just ID and our member card (electronic member card also available); and free from the trouble of preparing and submitting various documents for insurance claims.', //
    `Since March 2021, the company has enrolled to be the member of Medilink-Global. Because of the frenquent flyers of senior managements, especially between Hongkong, Singapore, Australia,  the company urgently needs a global medical program (excluding US)  which can cover inpatient, oupatient benefits, in the mean time , there are more concerns on the operation issues. Because their managements are mainly Chinese, language issue is critial not only for convenience but also for overseas call cost. MediLink-Global immediately kicked-off research on how to make them call the CS call center in China by dialing local call instead of overseas call.   Medilink-Global quickly worked with overseas partners arrange hotline services in these three countries, so as no more overseas call charges to their employees.  Further more, Wechat services are not convenient in these countries, MediLink-Global's tech team developed PC based solutions for enrollment, claim reporting, and other web-based services.  Those changes and improvement were completed in just few weeks contributed by the experienced IT team.  The actions were highly praised by the customers.`, //65
    `As one of the leading travel service company in China, the Company offers faborable medical benefits plan for its employees. Medilink-Global was selected as medical services provider in 2021, and provide tailor-made medical package to cover inpatient, outpatient, maternity, dental , physical examination, and other benefits. Besides the planned services package, MediLink-Global also quickly responds to its special or emerging needs, such as improving its current group physical examination arrangement by combining the cost and payment into its medical program.    This improvement substainly reduces the labor load of HR/Finance but also a better employee health management for its employees.  

        Compared with traditional service provider,  MediLink-Global has combined capabilities of medical network, medical related services, and new technology; therefore, we are more than willing to try new initiative and offer innovative operation and services to meet the customer's needs. `,
    `Upon joining the progarm, the company had been looking for an extensive program to cover inpatient, outpatient, dental needs, but also high-end medical program for the senior managerial level in Beijing, Shanghai, Suzhou etc.  Our nation-wide hospital network and the flexibility of extending the network exactly meet the requirement, and the company also looked into the  capability of providing high-end medical services for their senior management when having business travels.  In 2021, one of the staff engaged in arguement with the dental clinic when settling his self-paid charges.  Though it's not under the coverage, MediLink-Global still quickly involved in and negotiate on behalf of his interests.  This quick and active response was highly appreciated and confirmed.`,
    `MediLink-Global alwasy commits to protect customers' interests and to provide in time support or assistance for our members and customers.`, //***** */
    `The company has been a high-end medical program buyer for several years and switched to Medilink-Global program since Nov. 2020.  This change is mainly because MediLink-Global can provide one-stop services to cover comprehensive health management, health consulting service, and insurance associated services including but not limited to inpatient, outpatient, maternity, physical checkup, vision,  dental, mental health, and travel safety services. In order to provide these extensive services, several departments of MediLink-Global demonstrated the teamship to ensure customer's staff either Chinese or Foreigner can easily access insurance services and relevant value-added services, by convenient IT platform and bi-lingual services. In the daily services, the customer also establishes trust and relationship with the servies team.  In early 2021, a foreign employee of the customer carelessly lost his medical records/documents at a public hospital which was necessary for insurance claim.  Upon awaring the situation, his Account Manager immediately contacted MediLink-Global Network Department to provide on-site assistance, especially negotiating with hospital and help him to go through the required process to recover the documents and to get reimbursement.  Do our best to offer convenience and assistance to our customers is the doctrine and principle what we believe!  We awared of the case when he conveyed his praise "perfect service" to encourage our colleague.`,
    "", //70
  ],
  // 中间带杏带
  yixing: [
    "Medical Services"
  ],
  //新燕宝
  productDetails: [
    "Options",
    "Plan A",
    "Plan B",
    "The insured’s date of birth",
    "Note: 30 days (inclusive) – 17 years old (inclusive)", //5
    "Coverage description",
    "Annual Limti for hospitalization and day treatment",
    "Annual Limit for outpatient services",
    "Annual Limitate for emergency treatment",
    "RMB300,000", //10
    "RMB50,000",
    "RMB2,000",
    "Optional benefits",
    "Upgraded service pack",
    "Dental", //15
    "RMB500,000",
    "RMB4,000",
    "Insurance Premium",
    "Check account limit",
    "Buy Now", //20
    "Inquiry",
    "Product Description",
    "Notes for Application for Insurance",
    "References", //25
    "Information Disclosure",
    `<p >1. This product is intended for the enrolled aged from 30 days after birth to 17 years old. The insured must be the child of the applicant. For the insured who are aged from 30 days to 1 year old (inclusive) at the time of application for insurance and whose health declaration is not accepted, birth certificate and discharge summary must be provided.<br/><br/>
        2. For the insured who apply for the insurance for the first time or who is not continuously insured, the waiting period for hospitalization for all diseases is thirty (30) days since the insurance effective, outpatient emergency treatment is not subject to waiting period, and the insurance period is one (1) year.<br/><br/>
        3. Designated medical institutions: 1) public hospitals, including general department and special department of public hospitals at or above level 2, exluded international department ; 2) private hospitals: designated private hospitals on our latest list, excluding all hospitals in Pinggu, Miyun and Huairou in Beijing.<br/><br/>
        4. If the insured has been reimbursed for medical expenses from free medical services, basic social medical insurance or other expense reimbursement medical insurance, the remaining unreimbursed medical expenses net of the deductible stated in the policy will be reimbursed by the insurer at the reimbursement ratio agreed in the policy.<br/><br/>
        5. Guaranteed renewal does not apply to this product. The applicant is advised to fully understand that the insurer is likely to stop selling or making changes to this product due to this product’s failure to achieve the expected profitability. Benefits for continuous coverage are subject to that announced by the insurer when the insured apply for continuous coverage.<br/><br/>
        6. Consultation hours acceptable to the insurer at the designated private hospitals: The insurance coverage of this product only applies to the medical expenses incurred by the insured as a result of medical consultation at the designated hospitals during the acceptable consultation hours, and does not apply to the medical expenses incurred by the insured as a result of medical consultation at the designated hospitals during the non-acceptable consultation hours (the applicant must check the acceptable consultation hours as stated in the list of designated hospitals in the user manual before the insured seeks consultation).<br/><br/>
        7. The outpatient emergency treatment expenses at private hospitals will be reimbursed by means of direct billing, and the insured only need to pay deductibles rather than all the medical expenses incurred. If the insured pay all the medical expenses incurred and then make a claim from the insurer, the insurer will not reimburse the insured for any medical expenses that should be reimbursed by the insurer but are paid by the insured. Medical expenses incurred at public hospitals are subject to reimbursement claim but not subject to direct billing. For the specific procedures, see the section “Non-direct Billing Service” in the Service Manual.<br/><br/>
        8. Some private hospitals may charge contingent expenses. The applicant must read the hospital description of the designated hospitals as stated in the user manual before the insured seeks consultation.<br/><br/>
        9. This product excludes liability for the following:<br/><br/>
        1) Expenses for family disease screening, home nursing, professional nursing, hospice care, congenital diseases and symptoms, and sleep examination and treatment;<br/><br/>
        2) Massage, health care and treatment products for private use;<br/><br/>
        3) Vision correction fee and dental expense (if dental benefit pack is purchased, reimbursement will be available based on optional benefits);<br/><br/>
        4) Expenses for routine health examinations and immunization of infants and young children, except as otherwise agreed herein;<br/><br/>
        5) Other items excluded from liability as stipulated in insurance clauses.<br/><br/>
        10. Expense of one-time flu vaccination is reimbursable under this product (such vaccination is deemed as an outpatient visit)<br/><br/>
        11. A registration of the insured at the same department in the same hospital in one day is deemed as an outpatient visit.<br/><br/>
        12. If the applicant or the insured is a lawyer or medical worker or takes on any high-risk occupation, the application for insurance will not be accepted until it is confirmed by the underwriter.
        After the application for insurance is accepted, you may log in to 618bao.force.com/Customer to download and save the electronic policy, or visit the insurer’s official website<br/><br/></p>`, //27
    `<p><a target="_blank" href="https://image.ssish.com/static/product/ZLXYB2022/file/ZLXYB2022_sc.pdf">Xinyanbao Insurance Clauses 2022</a><br><br>
            <a target="_blank" href="https://image.ssish.com/static/product/ZLXYB2022/file/ZLXYB2022_sc.pdf">Xinyanbao Manual 2022</a><br><br>
            <a target="_blank" href="https://image.ssish.com/static/product/ZLXYB2022/file/ZLXYB2022_slyljg.jpg">Private Medical Institutions</a><br><br>
            <a target="_blank" href="https://midesk.ssish.com/visitor/material/materialDetail/LdePVNk3JiHSaXc5N7godA==">Value-added Services</a><br><br>
            <a target="_blank" href="https://ssish.oss-cn-hangzhou.aliyuncs.com/static/product/ZLXYB2022/file/ZLXYB2022_list.xlsx" download="线上送药服务药品清单.xlsx">List of drugs for online drug delivery service</a><br><br>
        </p>`, //28
    //问答
    "What is the age range for the insured?",
    "This product is intended for minors with permanent residence in China who are aged from 30 days to 17 years old and can live a normal life.", //30
    "What is the reimbursement ratio for outpatient medical expenses?",
    "First 5 visits for outpatient emergency treatment: special department of public hospitals: 80%; other: 100%. Visits after the first 5 visits: 50%. No limit on outpatient visits exists if upgraded service pack is purchased.",
    "Is there any limit on sum insured for physical examination and vaccine benefits?",
    "The sum insured for physical examination is limited to RMB1,500. Vaccine and vaccination expenses are 100% reimbursable.",
    "Is there any designated hospital for dental visit?", //35
    "No. All private medical institutions partnering with us are acceptable.",
    "Is this available to foreign children? Is there any requirement on permanent residence duration in China?",
    "This is available to foreign children. There is no requirement on permanent residence duration in China. Please note, however, that our insurance liabilities are effective only within the territory of mainland China.",
    "What is the maximum amount of claims that can be made in the official account for offline claims?",
    "Only the reimbursement claim for medical expenses incurred at public hospitals is acceptable. Any claim less than RMB3,000 can be directly made in the official account.", //40
    "Is there any discount for application for insurance for 2 children (inclusive)?",
    "No discount.",
    "From RMB",
    `<div class="table" style="border: solid 1px #f0f0f0; margin: 20px">
    <div
      class="header"
      style="display: flex; justify-content: space-evenly"
    >
      <div
        class="block"
        style="
          border-bottom: solid 1px #f0f0f0;
          width: 153px;
          text-align: center;
          background: #fcfcfc;
          font-size: 16px;
          font-weight: 500;
          padding: 10px;
        "
      >
      Module
      </div>
      <div
        class="type"
        style="
          border-bottom: solid 1px #f0f0f0;
          border-left: solid 1px #f0f0f0;
          border-right: solid 1px #f0f0f0;
          width: 418px;
          text-align: center;
          background: #fcfcfc;
          font-size: 16px;
          font-weight: 500;
          padding: 10px;
        "
      >
      Overview
      </div>
      <div
        class="content"
        style="
          border-bottom: solid 1px #f0f0f0;
          width: 577px;
          text-align: center;
          background: #fcfcfc;
          font-size: 16px;
          font-weight: 500;
          padding: 10px;
        "
      >
      Particulars
      </div>
    </div>
    <div class="t-content" style="display: flex; justify-content: left">
      <div class="block-content" style="width: 160px">
        <div
          class="plat"
          style=" height: 640px; text-align: left; display:flex; align-items:center"
        >
        <span>Information Disclosure Concerning Platform and Sales Business</span>
        </div>
        <div
          class="sale"
          style="
            border-top: 1px solid #f0f0f0;
            text-align: left;
            display:flex; 
            height: 590px;
            align-items:center;
          "
        >
       <span> Information Disclosure Concerning Sales Business</span>
        </div>
      </div>
      <div
        class="item-type"
        style="
          border-left: solid 1px #f0f0f0;
          border-right: solid 1px #f0f0f0;
          width: 399px;
        "
      >
        <div class="type-one" style="width: 399px">
          <div
            class="plat-item"
            style="
              border-bottom: 1px solid #f0f0f0;
              padding: 20px;
              height: 131px;
            "
          >
          (I) Insurer and insurance underwriter of insurance product, and a list of provinces, autonomous regions and municipalities where the insurer has branches;
          </div>
          <div
            class="plat-item"
            style="border-bottom: 1px solid #f0f0f0; padding: 20px"
          >
          (II) The form of insurance contract; if an electronic policy is used, please specify;
          </div>
          <div
            class="plat-item"
            style="border-bottom: 1px solid #f0f0f0; padding: 20px"
          >
          (III) Payment method of premiums, and delivery method and rates of insurance certificates, invoices for payment of premiums and other documents;
          </div>
          <div
            class="plat-item"
            style="
              border-bottom: 1px solid #f0f0f0;
              padding: 20px;
              height: 95px;
            "
          >
          (IV) The ways how to seek advice on application for insurance, inquire policies and submit complaints;
          </div>
          <div
            class="plat-item"
            style="border-bottom: 1px solid #f0f0f0; padding: 20px;height:112px;"
          >
          (V) Procedures of application for insurance, acceptance of application for insurance, claims, preservation and insurance cancellation, as well as payment methods of claims, surrender value and premiums;
          </div>
          <div
            class="plat-item"
            style="border-bottom: 1px solid #f0f0f0; padding: 20px; height:131px"
          >
          (VI) Measures in place to ensure the security of personal information of the applicant (the insured or the beneficiary), insurance transaction information, and insurance transactions;
          </div>
        </div>
        <div class="type-two">
          <div
            class="sale"
            style="border-bottom: 1px solid #f0f0f0; padding: 20px"
          >
          Important
          </div>
          <div
            class="sale"
            style="border-bottom: 1px solid #f0f0f0; padding: 20px;height:113px"
          >
          (I) Name (name used in contractual terms and name used in ads) and approval number, recordation number or declaration number of insurance product;
          </div>
          <div
            class="sale"
            style="border-bottom: 1px solid #f0f0f0; padding: 20px"
          >
          (II) Insurance clauses and premium rates (or links to insurance clauses and premium rates). In particular, the clauses discharging the insurer from liability should be underlined and elaborated, and key terms and conditions such as claims requirements, cooling-off period mentioned in insurance contract, deductions, loss caused by insurance cancellation and surrender value should be underlined and indicated in an appropriate way;
          </div>
          <div
            class="sale"
            style="
              border-bottom: 1px solid #f0f0f0;
              padding: 20px;
              height: 131px;
            "
          >
          (III) The insured’s obligation of truly disclosure, and the consequences of breach thereof;
          </div>
          <div
            class="sale"
            style="
              border-bottom: 1px solid #f0f0f0;
              padding: 20px;
              height: 94px;
            "
          >
          (IV) The territory where insurance product is sold;
          </div>
          <div class="sale" style="padding: 20px">
          (V) Other matters that directly affect the interests and purchase decision-making of consumers.
          </div>
        </div>
      </div>
      <item class="content" style="width: 600px">
        <div class="content-one">
          <div
            class="content-item"
            style="border-bottom: 1px solid #f0f0f0; padding: 20px"
          >
          1. Liberty Insurance Company Limited acts as the insurer of this product. The insurer currently has branches in Chongqing, Sichuan, Beijing, Guangdong, Shandong, Zhejiang and Ningbo in the People’s Republic of China (excluding Hong Kong, Macau and Taiwan). Customers may purchase this product through the website 618baoxian.com and deal with subsequent changes and claims with the assistance of this platform.
            
          </div>
          <div
            class="content-item"
            style="
              border-bottom: 1px solid #f0f0f0;
              padding: 20px;
              height: 172px;
            "
          >
          The insurance contract is made in the form of electronic policy, which is available on the website http://www.libertymutual.com.cn/. If a paper policy or invoice is needed, please call the customer service hotline of 618baoxian.com at 400-820-3433. The paper policy or invoice will be sent via mail.
          </div>
          <div
            class="content-item"
            style="border-bottom: 1px solid #f0f0f0; padding: 20px"
          >
          You may visit the website http://www.libertymutual.com.cn/ or call the customer service hotline at 400-888-2008 for the ways how to seek advice on application for insurance, inquire policies or submit complaints.
          </div>
          <div
            class="content-item"
            style="
              border-bottom: 1px solid #f0f0f0;
              padding: 20px;
              height: 112px;
            "
          >
          See product description above
          </div>
          <div
            class="content-item"
            style="border-bottom: 1px solid #f0f0f0; padding: 20px"
          >
          The company observes all the national laws and regulations on the protection of personal information, data and privacy, and takes all the necessary technical measures and systematic management measures to protect the personal information and data you provide to the company and your privacy from illegal disclosure or from divulgence to unauthorized third parties.
          </div>
        </div>
        <div class="content-two">
          <div
            class="content-two-item"
            style="border-bottom: 1px solid #f0f0f0; padding: 20px"
          >
          See the section “Notes for Application for Insurance” for details
          </div>
          <div
            class="content-two-item"
            style="
              border-bottom: 1px solid #f0f0f0;
              padding: 20px;
              height: 113px;
            "
          >
          See product description for details
          </div>
          <div
            class="content-two-item"
            style="
              border-bottom: 1px solid #f0f0f0;
              padding: 20px;
              height: 185px;
            "
          >
          See the section “Insurance Clauses” for details
          </div>
          <div
            class="content-two-item"
            style="border-bottom: 1px solid #f0f0f0; padding: 20px"
          >
          In accordance with relevant provisions of the Insurance Law of the People’s Republic of China, both the applicant and the insured are under the obligation of truly disclosure, and the insurer has the right to terminate insurance contract and be excused from insurance liability in the event of breach of such obligation. For details, see the section “Obligations of the Applicant and the Insured” in terms and conditions of this product.
          </div>
          <div
            class="content-two-item"
            style="
              border-bottom: 1px solid #f0f0f0;
              padding: 20px;
              height: 94px;
            "
          >
          See the section “Notes for Application for Insurance” for details.
          </div>
          <div class="content-two-item" style="padding: 20px">
          Please read carefully the section “Notes for Application for Insurance” to have an idea of the important matters affecting insurance purchase decision-making
          </div>
        </div>
      </item>
    </div>
  </div>
    `,
    "due date",
    "Liberty Maternal-infant Medical Insurance Clauses (Clause C)",
    "Xiyanbao Manual 2021",
    "Private Medical Institutions",
    "Product Name",
    "Product Description",
    "Premium Dalculation", // 49 
  ],
  // 顶部菜单
  header: [
    "Home",
    "Product Family",
    "Third-party Management Services",
    "Medical Network",
    "Medical Services", //5
    "About Us",
    "Sign In",
    "Corporate Health Management Solutions",
    "Personal Health Management Solutions",
    "Corporate Customized Solutions", //10
    "Xinyanbao",
    "Xiyanbao",
    "Fuyanbao",
    "Xiaoyanbao",
    "Zhenrongyao", //15
    "Third-party Management Services",
    "Membership Services",
    "Special Services",
    "MediLink Global YiXing Medical",
    "Corporate Health Service", //20
    "Member Login",
    "Provider Login",
    "Partner Login",
    "Medilink Global Assist",
  ],
  options: [
    'YES',
    'NO',
    "Europe",
    "Singapore",
    "Japan",
    "Korea",
    "USA",
    "Canada",
    "Other",
  ],
  
  //臻荣耀
  zhenrongyao: [
    "Target group:",
    "Period:",
    "Plan:",
    "Effective date:",
    "Territory:",
    "Deductible for inpatient expenses:", //5
    "Hospitals covered:",
    "Hospitals covered:",
    "Optional dental benefits:",
    "Optional physical examination benefits:",
    "Premium:", //10
    "Date of Birth",
    "Buy Now",
    "Inquiry",
    "From RMB",
    "Enrolled age is from 15 days after birth to 64 years old; the maximum renewal age is 75 years old", //15
    "Golden plan",
    "Platinum plan",
    "Diamond plan",
    "Star plan",
    "One year", //20
    "N/A",
    "Enrolled age is from 30 days after birth to 17 years old;",
    "18-40 years old",
    "Plan 1",
    "Plan 2", //25
    "Insurance scheme",
    "Pregnancy cycle",
    "1-8 weeks",
    "9-12 weeks",
    "13-16 weeks", //30
    "17-20 weeks",
    "21-24 weeks",
    "25-28 weeks",
    "28-32 weeks",
    "33-36 weeks", //35
    "37-40 weeks and above",
    "Information Disclosure", //信息披露
    "Claim Services", //38
    "1.Insured age is from 15 days to 64 years old; the maximum renewal age is 75 years old.",
    "2.The spouse or child of the main insured (child must under age 21; Fill-time student must be under age 26) can be regarded as the additional insured of this contract. Child aged form 0 to 17 only can be regarded as additional insured.",
    "3.During the period of insurance，the insured should reside in mainland China for a total of 180 days or more.",
    "4.The insurance liability is subject to underwriting confirmation, if the policy holder or the insured occupation is a lawyer, a medical practitioner, or a high-risk professional.",
    "5.Pre-Authorization",
    "Some special treatment items in the insurance plan require Pre-authorization. Before receiving these treatments, customers need to confirm in advance whether the treatment costs can be covered and what the compensation standard is.",
    "Treatment items that require Pre-authorization include:",
    "1. Inpatient treatments",
    "2. Any outpatient surgery requiring general anesthesia",
    "3. Radiotherapy and chemotherapy",
    "4. Cancer treatment",
    "5. Home health care including nursing services",
    "6. Dialysis or peritoneal dialysis",
    "7. Purchase or rent non-disposable durable medical equipment, including but not limited to insulin pumps and their associated equipment",
    "8. Organs, bone marrow, stem cells and other tissues transplant",
    "9. Emergency medical evacuation",
    "10. Each visit cost more than RMB 8,000",
    "11. Alcohol and drug abuse withdrawal treatment",
    "12. Sleep examination and treatment for suspected paroxysmal sleep or obstructive apnea",
    "13. Any treatment that does not comply with items 1 to 12 but has a cumulative medical cost of more than RMB 40,000 during the insurance period ",
    "If the client does not obtain written permission from the medical service center to reply before the above-mentioned treatment, and the insured receives medical treatment, the insurer has the right not to bear the insurance liability. In case of an emergency, the insured only needs to notify within 48 hours of the emergency",
    "6.Pre-existing Condition",
    "Within 30 days (including the 30th day) before the expiration of the insurance period of this contract, the insured can apply to the insurer for re-insurance of this contract, and the insurer can also send an invitation to the insured to re-insure this contract. Within 30 days after the expiration of the insurance contract, if the applicant applies and the insurer agrees to continue to issue the policy, the next year's policy and the previous year's policy will be consecutive in time, and the insurer will no longer set a waiting period. ",
    "Liberty Personal Global Insurance Clauses (Clause A)",
    "Rate Schedule",
    "List of Medical Institutions",
    "Zhenrongyao 2022 Plan",
    "Service Manual",
    `<p>
    <strong>[Hotline]</strong>
    <br><br>MediLink-Global offers 7X24 service hotline:
    <br><br>In China: 400-114-9606
    <br><br>Outside China: +86 10 6552 5313
    <br><br>E-mail: customerservice@medilink-global.com.cn
    <br><br>We offer you an exclusive Chinese-English bilingual service hotline, enabling you to enjoy our 7X24 considerate services anytime and anywhere.
    <br><br>
    <strong>[MediLink-Global offers the following customer services]</strong>
    <br><br>1. Confirm whether you are within the valid period of insurance;
    <br><br>2. Preliminarily determine whether the treatment services you need are covered by the policy;
    <br><br>3. Help you choose a suitable hospital offering direct billing service according to your insurance plan;
    <br><br>4. Assist you in the application for and approval of pre-authorization;
    <br><br>5. Assess whether the therapies recommended by the doctor are necessary and effective;
    <br><br>6. Assist you in requesting for subsequent claim payments;
    <br><br>7. Help to meet your needs for emergency assistance;
    <br><br>
    <strong>[Pre-authorization]</strong>
    <br><br>Before receiving the following treatment items, the insured must submit a pre-authorization application to the insurer’s medical service center no later than five working days prior to the scheduled treatment date:
    1. Inpatient treatments;<br><br>
    2. Any outpatient surgery requiring general anesthesia;<br><br>
    3. Radiotherapy and chemotherapy;<br><br>
    4. Cancer treatment;<br><br>
    5. Home health care including nursing services;<br><br>
    6. Dialysis or peritoneal dialysis;<br><br>
    7. Purchase or rent non-disposable durable medical equipment, including but not limited to insulin pumps and their associated equipment;<br><br>
    8. Organs, bone marrow, stem cells and other tissues transplant;<br><br>
    9. Emergency medical evacuation;<br><br>
    10. Each visit cost more than RMB8,000;<br><br>
    11. Alcohol and drug abuse withdrawal treatment;<br><br>
    12. Sleep examination and treatment for suspected paroxysmal sleep or obstructive apnea;<br><br>
    13. Any treatment that does not comply with items (1) to (12) but has a cumulative medical cost of more than RMB40,000 during the insurance period;<br><br>
    14. Please see the Claim Guide for details.<br><br>
    How to get pre-authorization: <br><br>
    You can get a Pre-authorization Application in “Pre-authorization” of the WeChat official account “MediLink-Global Online” or by emailing to the customer service email address. A duly completed Pre-authorization Application can be submitted through the WeChat official account above or by calling the customer service hotline or emailing to the customer service email address. <br><br>
    How to apply for pre-authorization: <br><br>
    1)You must submit a pre-authorization application to the MediLink-Global customer service center no later than 3-5 days before receiving the above treatment items, so that MediLink-Global can receive and review such application before the scheduled treatment date. <br><br>
    2)(The MediLink-Global customer service center will give a written reply to the application within 48 hours after all the necessary materials are received. If the estimated medical expenses for which you apply for pre-authorization are too high (over RMB50,000) or the estimated treatment duration lasts too long, more time will be required for review (in no case more than 5 working days). You must not receive any treatment item until a written reply approving your application for pre-authorization is obtained.<br><br>
    3)You should understand that pre-authorization is hardly feasible in the event of any emergency, and in this case, you or your family can advance outpatient and emergency medical expenses or deposit for admission to hospital and transact admission formalities, and then get in contact with the MediLink-Global customer service center for pre-authorization within 48 hours after the emergency occurs.
    <br><br>

    <strong>[Claim process at hospitals offering no direct billing service] </strong>
    <br><br>If you make a medical visit to any medical institution offering no direct billing service, you need to advance all medical expenses and then request us for reimbursement. In this case, you need to submit the following materials within 30 days upon completion of treatment:
    <br><br>Duly completed Claim Application Form
    <br><br>All related medical expense invoices and statements
    <br><br>Complete medical records, and in the case of hospitalization, a discharge summary
    <br><br>Related examination and testing reports, drug descriptions, etc.
    <br><br>
    <strong>[Mailing address]</strong>
    <br><br>Attention: High-end Medical Service Group
    <br><br>
    Head office address:10F, Jingtai Tower, No. 24, Jianguomenwai Street, Chaoyang District, Beijing
    <br><br>Shanghai office address: F3, Jianhua Building, No. 85, Lane 623, Wanhangdu Road, Jing'an District, Shanghai
    <br><br>Fax: +86 10 8453 9719
    <br><br>Tel.: 400-114-9606
    <br><br>MediLink-Global will email the claim notice to you and inform you of the results. Regardless of full or partial reimbursement, final claim payments will be paid to your designated account by bank transfer. You can also view the progress and results of claim review in “My Claims” on MediLink-Global’s WeChat official account “MediLink-Global Online”.
</p>`,
    "Mainland China",
    "Greater China",
    "Worldwide Excluding USA",
    "Worldwide",
    "Public hospital covered only",
    "Public hospital and private hospital excluding high-cost provider",
    "High-cost provider covered",
  ],
  //新燕宝投保须知
  xinyanbaoxuzhi: [
    `1. This product is intended for healthy pregnant women at the age of 18-40 years old. All previous antenatal care reports of the insured must be provided. <br/><br/>
        2. The live newborn delivered by the primary insured during the insurance period will automatically become the additional insured of this product from the date of birth, provided, however, that the applicant must timely inform the insurer of the birth after the birth of newborn. Where the applicant informs the insurer of the birth within thirty (30) days (inclusive) after the birth of newborn, the insurer will assume the insurance liability for the newborn from the date of birth; where the applicant informs the insurer of the birth thirty (30) days after the birth of newborn, the insurer will, upon review and approval, assume the insurance liability for the newborn from the effective date of the insurance coverage for the additional insured as stated in the written request from the applicant. During the insurance period, the insurer will not charge additional premiums to the additional insured. <br/><br/>
        3. The insurance coverage offered by this product applies to general department and special department (excluding international department and special consultation department) of public hospitals at the second and above level in mainland China, as well as private medical institutions designated by the insurer (see the latest list announced by the insurer for details), but does not apply to any and all hospitals in Pinggu District, Miyun County and Huairou District in Beijing. <br/><br/>
        4. If the insured has been reimbursed for medical expenses from free medical services, basic social medical insurance or other expense reimbursement medical insurance, the insurer will pay to the insured the insurance claims at the ratios of claims payment agreed in the policy based on the medical expenses actually incurred by the insured net of the deductible stated in the policy and the aforementioned reimbursed expenses. <br/><br/>
        5. This product has an insurance period of one (1) year without guaranteed renewal of insurance. <br/><br/>
        6. About the consultation hours acceptable to the insurer at the designated private medical institutions: The insurance coverage of this product only applies to the medical expenses incurred by the insured as a result of medical consultation at the designated medical institutions during the acceptable consultation hours, and does not apply to the medical expenses incurred by the insured as a result of medical consultation at the designated medical institutions during the non-acceptable consultation hours (the applicant must check the acceptable consultation hours as stated in the list of designated private medical institutions in the user manual before the insured seeks consultation).<br/><br/> 
        7. This product offers direct billing service at the private medical institutions designated by the insurer. With the direct billing service, the insured does not need to pay all medical expenses and only need to pay the self-paid expenses as agreed in this product. If the insured requests for claims from the insurer after using the direct billing service, such request will be rejected by the insurer. This product offers reimbursement claim but no direct billing at public hospitals. For the claim process, please see the user manual of this product for details. <br/><br/>
        8. Some private hospitals may charge contingent expenses. The applicant must read the hospital description of the designated hospitals as stated in the user manual before the insured seeks consultation. <br/><br/>
        9. Before applying for insurance, pregnant women whose previous pregnancy risk assessment and grading results are all low-risk (green or blue) must provide a valid antenatal care manual containing pregnancy risk assessment and grading results and fill in health declaration. Pregnant women whose previous pregnancy risk assessment and grading result is general risk (yellow) must fill in health declaration and provide all the antenatal care reports related to the birth and all the medical records of previous visits for underwriting. <br/><br/>
        10. Once insured, any changes in pregnancy risk assessment and grading results of the insured’s subsequent antenatal care will not affect the underwriting decision made at the time of application for insurance. <br/><br/>
        11. The underwriter must evaluate the insured’s health status and the severity of the insured’s previous diseases according to the health declaration and other related materials provided by the insured, and decide on normal underwriting, additional premiums, limits, exceptions or rejection to application for insurance. Claims for unaudited pre-existing diseases and related complications will not be accepted. Under the national and local pregnancy risk assessment and management systems, pregnant women whose previous pregnancy risk assessment and grading results are low-risk (green or blue) or general-risk (yellow) before application for insurance are eligible for this insurance, and those whose previous pregnancy risk assessment and grading result is higher-risk (orange), high-risk (red) or infectious (purple) are not eligible for this insurance. The insured must provide an antenatal care manual containing pregnancy risk assessment and grading results when applying for insurance, or if fails to do so, will not be allowed to apply for insurance. This product does not apply to women who are in multi-fetal pregnancy (including gemellary pregnancy) or get pregnant through artificial ways. <br/><br/>
        12. The insurance coverage of this product covers the following complications: <br/><br/>
        1) 30 prenatal complications: pregnancy-induced hypertension, acute fatty liver, chorea during pregnancy, preeclampsia, hyperemesis gravidarum, abnormal umbilical cord, intrahepatic cholestasis during pregnancy, contour placenta, uterine prolapse, placenta previa, vascular previa, intestinal obstruction during pregnancy, placental abruption, polyhydramnios, perinatal cardiomyopathy, blood type incompatibility between mother and infant, oligohydramnios, osteomalacia during pregnancy, gestational diabetes, premature rupture of membranes, hypercortisolism during pregnancy, pregnancy-induced myocardial infarction, fetal growth retardation, hemolytic uremic syndrome during pregnancy, venous thromboembolism during pregnancy, fetal distress, pregnancy-induced HELLP syndrome, acute pyelonephritis during pregnancy, neonatal asphyxia, and pulmonary hypertension during pregnancy <br/><br/>
        2) 8 intrapartum complications: uterine rupture, amniotic fluid embolism, cervical and vaginal laceration, inverted uterus, postpartum hemorrhage, obstetric shock, obstetric diffuse intravascular coagulation, and amniotic cavity infection syndrome <br/><br/>
        3) 11 postpartum complications: puerperal infection, postpartum depression, postpartum urinary retention, postpartum peripheral nerve complications, mastitis, perineum tearing and infection, late postpartum hemorrhage, postpartum uterine infection, sub-involution of uterus, postpartum acute renal function decline, and rupture of placental marginal sinus<br/><br/>
        4) For postpartum depression, claims will be paid up to a maximum of 90 days and up to 2 hours in total<br/><br/>
        13. Exclusion of liability: This product excludes liability for the following:<br/><br/>
        1) Family disease screening, home nursing, professional nursing, hospice care, congenital diseases and symptoms, sleep examination and treatment; mental diseases, and psychological counseling; <br/><br/>
        2) Massage, health care and treatment products for private use; <br/><br/>
        3) Vision correction and dental services; <br/><br/>
        4) Routine health examinations and immunization of infants and young children, except as otherwise agreed herein; <br/><br/>
        5) Other items excluded from liability as stipulated in insurance clauses;<br/><br/> 
        6) The policy will become void after payment of miscarriage compensation;<br/><br/> 
        7) All treatment expenses no related to childbirth and newborn care; <br/><br/>
        8) Pre-existing diseases; <br/><br/>
        9) Medical expenses exceeding regular expenses; <br/><br/>
        10) Surgical and neonatal care and treatment costs related to surrogacy and IVF; <br/><br/>
        11) Medical expenses of and related to selective caesarean section; <br/><br/>
        12) Uterine rupture caused by scarred uterus; blue light therapy costs of physiological jaundice; fetal suction and midwifery costs; miscarriage prevention expenses; <br/><br/>
        13) Prenatal and postnatal care related expenses.<br/><br/>
        14. If the applicant or the insured is a lawyer or medical worker or takes on any high-risk occupation, the application for insurance will not be accepted until it is confirmed by the underwriter.`,
  ],
  //福燕宝须知
  fuyanbaoxuzhi: [
    `1) Applicant: A natural person who is aged 16 or above, has full capacity for civil conduct and has an insurable interest in the insured may apply for this product (such natural person may apply for insurance for himself/herself or his/her spouse, children or parents).<br/><br/>
        2) Insured: This product is intended for the insured aged 46-80 years old (inclusive).<br/><br/>
        3) Beneficiary: Unless otherwise agreed, the insured is the beneficiary of all the insurance benefits provided by this product.<br/><br/>
        4) Insurance period: This product has an insurance period of one (1) year commencing from 00:00 a.m. on the day immediately after the application for insurance is accepted.<br/><br/>
        5) Cooling-off period: This product has no cooling-off period. Please stay cautious when deciding to apply for insurance.<br/><br/>
        6) Waiting period: For the insured who apply for insurance for the first time, inpatient treatment is subject to a waiting period of thirty (30) days, and outpatient treatment is subject to no waiting period.<br/><br/>
        7) Renewal rules:<br/><br/>
        ① This product has an insurance period of one (1) year without guaranteed renewal of insurance. Upon the expiry of the insurance period, the insured need to re-apply for insurance to the insurer, pay premiums again, and conclude a new insurance contract.<br/><br/>
        ② If this product is unavailable on the market, no application for insurance will be accepted from the date of the unavailability. In this case, we will disclose the reasons for and starting and ending dates of the unavailability, follow-up service measures and other information in a way that is easily accessible to the public, continue to provide insurance services to the existing insured during the insurance period, and provide the insured with necessary and reasonable reinsurance services when the insurance period comes to an end.<br/><br/>
        8) For the designated private medical institutions of this product, see the list in the service manual for details. The designated public hospitals of this product mean public medical institutions at the second level and above in mainland China. The special medical institution of this product means Shanghai Proton and Heavy Ion Center which adopts the same reimbursement standards as that of general department at public hospitals.<br/><br/>
        9) Deductible and reimbursement ratios:<br/><br/>
        ① The deductible of this product means annual deductible in which the part of medical expenses reimbursable by social insurance may be included.<br/><br/>
        ② For any medical expenses with reimbursement ratio agreed, such medical expenses net of deductible will be reimbursed by the insurer at the agreed reimbursement ratio.<br/><br/>
        ③ Inpatient medical expenses incurred at general department of public hospitals will be reimbursed by the insurer at a reimbursement ratio of 100%, and that incurred at special department and international department of designated private medical institutions and public hospitals will be reimbursed by the insurer at a reimbursement ratio of 60%.<br/><br/>
        10) Purchase restriction: Each insured is only allowed to purchase one this product during one insurance period. If any insured purchases more than one this product during one insurance period, he/she is only entitled to reimbursement under one this product.<br/><br/>
        11) Premium rates of this product are dependent on the age of the insured, and therefore will change as the age of the insured changes. The specific premium rates are subject to that calculated by the system each year when the insured apply for insurance.<br/><br/>
        12) If the applicant or the insured is a lawyer or medical worker or takes on any high-risk occupation, the application for insurance will not be accepted until it is confirmed by the underwriter.<br/><br/>
        
        Important Note<br/><br/>
        1. If you intend to apply for insurance, you ought to fulfill the obligation of truly disclosure before the application by filling in true and accurate information about application for insurance and giving true and accurate answers to the inquiries made by the insurer. If you fail to do so, the insurer has the right to terminate the insurance contract and be excused from liability for indemnity in pursuance to Article 16 of the Insurance Law of the People’s Republic of China. When an insurance contract is concluded, the applicant must give true and accurate answers to the inquiries regarding insurance subject or the insured made by the insurer. Where the applicant fails to perform the obligation of truly disclosure specified in the preceding paragraph on purpose or due to gross negligence, which is sufficient to affect the insures’ decision to accept or reject the application for insurance or to increase the premium rate, the insurer has the right to terminate the insurance contract. Where the applicant fails to perform the obligation of truly disclosure on purpose, the insurer will be excused from liability for indemnity for any and all covered accidents occurring before the termination of insurance contract, and will refund no premium. Where the applicant fails to perform the obligation of truly disclosure due to gross negligence, which exerts material effects on the occurrence of covered accidents, the insurer will be excused from liability for indemnity for any and all covered accidents occurring before the termination of insurance contract, and will refund premiums. If it is known to us when the insurance contract is concluded that you fail to perform the obligation of truly disclosure, we may not terminate the insurance contract and will pay claim payments for any and all covered accidents that have occurred.<br/><br/>
        2. If you apply for insurance, you, as needed for provision of insurance services and improvement of service quality: (1) authorize us and our partners to make certain the authenticity of the information regarding application for insurance and to inquire about and obtain the insured’s information related to application for insurance (including but not limited to health status, diagnosis and treatment records, medical history, etc.) before and after your application for insurance is accepted. Should you are found of any misstatement or concealment, we will terminate the insurance contract according to law; (2) authorize us to share your information (including but not limited to the information concerning application for insurance, acceptance of application for insurance and claims, medical information, etc.) with the institutions which have necessary cooperative relationships with us; and (3) authorize us and our partners to use your information reasonably and to inquire about all of your information through the institutions that know your information. For the sake of information security, we and our partners should take effective measures and assume the duty of confidentiality.<br/><br/>
        3. Third parties, including authorized employees of the insurer and other entities or individuals that work on our business, marketing activities and data collection, are likely to access and use your personal information on a need-to-know basis. All those entities and individuals must abide by relevant non-disclosure agreements and the applicable national laws and regulations on protection of personal information to ensure that your personal information is under protection at all times. Except for the above purposes, we will not use your personal information for any purposes not permitted by you. We will not divulge, tamper with, destroy, sell or disclosure any personal information in our possession to any third party except to our business partners, legal advisors and external auditors or except as required by laws and regulations, regulatory requirements or court rulings.`,
    "Clauses of Liberty Insurance Company Limited on Hospitalization Medical Insurance for the Middle-aged and Elderly (Version 2021)",
    "Designated Hospitals",
    "Service Manual",
    "years old",
    "Plan 1+Outpatient 3 times",
    "Plan 1+Outpatient 5 times",
    "Plan 2+Outpatient 3 times",
    "Plan 2+Outpatient 5 times",
  ],
  //小燕宝投保须知
  xiaoyanbaoxuzhi: [
    `1.This product is intended for the enrolled aged  from 30 days after birth to 17 years old. The insured must be the children of the applicant. At the option of the applicant, the policy may become effective as of the date when the premium is paid. <br/><br/>

        2. For the insured who apply for the insurance for the first time or who is not continuously insured, the waiting period for hospitalization for all diseases is thirty (30) days, outpatient emergency treatment is subject to no waiting period, and the insurance period is one (1) year. <br/><br/>
        
        3. For the designated private hospitals, please see the latest list announced by us. <br/><br/>
        
        4. Only inpatient treatment expenses incurred at the inpatient department of designated private medical institutions are reimbursable. <br/><br/>
        
        5. If the insured has been reimbursed for medical expenses from free medical services, basic social medical insurance or other expense reimbursement medical insurance, the insurer will pay to the insured 100% of the remaining unreimbursed medical expenses net of the deductible stated in the policy. <br/><br/>
        
        6. Guaranteed renewal does not apply to this product. The applicant is advised to fully understand that the insurer is likely to stop selling or making changes to this product due to this product’s failure to achieve the expected profitability. Benefits for continuous coverage are subject to that announced by the insurer when the insured apply for continuous coverage. <br/><br/>
        
        7. Consultation hours acceptable to the insurer at the designated private hospitals: The insurance coverage of this product only applies to the medical expenses incurred by the insured as a result of medical consultation at the designated hospitals during the acceptable consultation hours, and does not apply to the medical expenses incurred by the insured as a result of medical consultation at the designated hospitals during the non-acceptable consultation hours (the applicant must check the acceptable consultation hours as stated in the list of designated hospitals in the user manual before the insured seeks consultation). <br/><br/>
        
        8. The outpatient emergency treatment expenses at private hospitals will be reimbursed by means of direct billing, and the insured only need to pay deductibles rather than all the medical expenses incurred. If the insured pay all the medical expenses incurred and then make a claim from the insurer, the insurer will not reimburse the insured for any medical expenses that should be reimbursed by the insurer but are paid by the insured. <br/><br/>
        
        9. Some private hospitals may charge contingent expenses. The applicant must read the hospital description of the designated hospitals as stated in the user manual before the insured seeks consultation.<br/><br/> 
        
        10. The policy will become void after the outpatient services covered by this product are used by the insured for three (3) times (based on the number of registrations). This product may be re-purchased upon voidness. <br/><br/>
        
        Exclusions: <br/><br/>
        
        1) Outpatient surgery, and observation and treatment for more than six (6) hours; <br/><br/>
        
        2) Expenses for physiotherapy, acupuncture treatment, homeopathy, traditional Chinese medicine treatment, and purchase or lease of durable medical equipment;<br/><br/> 
        
        3) Expenses for major examinations and tests: hip ultrasound, electroencephalogram, UCG, lung function examination, CT, PET, MRI, endoscopy, food intolerance testing, insulin growth factor binding protein test, trace element test, endocrine test, and allergen test; <br/><br/>
        
        4) Expenses for family disease screening, home nursing, professional nursing, hospice care, congenital diseases and symptoms, sleep examination and treatment, genetic testing, developmental delay and assessment of growth and development, and growth hormone treatment, and other related expenses; <br/><br/>
        
        5) Expenses for various massage, health care and treatment products for private use, and cosmetic or plastic related expenses; <br/><br/>
        
        6) Expenses for vision correction, dental services, psychological consultation, and treatment of psychological and mental diseases; <br/><br/>
        
        7) Expenses for routine health examinations and immunization of infants and young children; <br/><br/>
        
        8) Expenses incurred due to pre-existing diseases that the insured has known or ought to know before application for insurance; <br/><br/>
        
        9) Medical expenses incurred by the insured at non-designated medical institutions; <br/><br/>
        
        10) Other items excluded from liability as stipulated in insurance clauses.<br/><br/>
         
        11) The following insurance clauses apply to this product: Medical Insurance Clauses of Liberty Insurance Company Limited on Hospitalization and Outpatient Emergency Treatment of Children (Version 2021) with registration number being C00006032512021020312811<br/><br/>
         
        12) For the insurance coverage and premium rates of this product, please see the sections “Product Description” and “References”. For the sake of your interests, you are advised to read carefully insurance clauses and insurance contract when applying for insurance, to pay special attention to the insurance clauses providing for insurance liability, special covenants, exemption the insurer from liability, cooling-off period, deductions, insurance cancellation and surrender value, and to understand the insurance coverage, basic insured amount, insurance period, payment deadline of premiums, premium rates and other information.<br/><br/>
         
        13) In accordance with relevant provisions of the Insurance Law of the People’s Republic of China, both the applicant and the insured are under the obligation of truly disclosure, and the insurer has the right to terminate insurance contract and be excused from insurance liability in the event of breach of such obligation. For details, see the section “Obligations of the Applicant and the Insured” in terms and conditions of this product.<br/><br/>
        14) If the applicant or the insured is a lawyer or medical worker or takes on any high-risk occupation, the application for insurance will not be accepted until it is confirmed by the underwriter.<br/><br/>
        
        15) All the insurance services related to this product are available online.
        Payment of premiums: Premiums of this product may be paid online, or if such payment fails, may be paid again by 24:00 on the day of application for insurance.<br/><br/>
        Claim payment will be directly paid into the designated bank account upon review and approval by the insurer.<br/><br/>
        Form of policy: This product offers electronic policy which, as stipulated in the Contract Law of the People’s Republic of China, enjoys the equal legal force and effect as policy in paper form. An electronic policy will be sent to you via e-mail or SMS after your application for insurance is accepted. You will be considered by the insurer to have received the electronic policy once the email or message is duly sent to you.
        Form of invoice: This product offers electronic invoice. Please visit http://www.libertymutual.com.cn/ to download or issue electronic invoice.`,
    "Insurer",
    "Liberty Insurance Company Limited",
    "Full name of the insurer",
    "Liberty Insurance Company Limited (MGU)",
    "Term of cooperation",
    "From September 27, 2019 to an indefinite date",
    "Scope of cooperation",
    "Accident insurance; health insurance",
    "Detailed information",
    `1. Liberty Insurance Company Limited, acting as the insurer of this product, has branches in Chongqing, Guangdong, Shandong, Beijing, Zhejiang, Sichuan, Hebei, Tianjin and Henan.<br/>
     2. To ensure your legitimate rights and interests, you may call the national customer service hotline at 4008882008 of Liberty Insurance Company Limited for insurance application consultation, policy inquiry, policy verification, claims consultation, complaints and suggestions, and other services. </br>
     3. For the sake of the security of customers’ personal information, insurance transaction information and insurance transactions, the insurer conducts encrypted transmission of information by using encrypted transmission protocol (https) or certificate in its Internet insurance business, so as to ensure the information security of the applicant and the insured and the security of users’ personal information. </br>
     4. For more information publicly disclosed by the insurer, please visit official website of Liberty Insurance Company Limited www.libertymutual.com.cn.`,
    "Xiaoyanbao Insurance Clauses 2021",
    "Xiaoyanbao Manual",
    "Designated Hospitals",
  ],
  // 福燕宝
  fuyanbao: [
    "Fuyanbao",
    "30 days to 100 years Old",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
};
